import React, { FC, memo } from "react";

import {
  IconContainerWrapper,
  IconContainerTitle,
  IconContainerText,
  IconContainerHeaderWrapper,
  IconContainerHeader,
} from "./styled";
import { ContainerProps } from "../types";

export const IconContainer: FC<ContainerProps> = memo(({ elementConfig, renderElement }) => {
  return (
    <IconContainerWrapper style={elementConfig?.style}>
      <IconContainerHeaderWrapper>
        <IconContainerHeader>
          {renderElement({ id: "icon" })}
          <IconContainerTitle>{renderElement({ id: "alias" })}</IconContainerTitle>
        </IconContainerHeader>
        {renderElement({ id: "link" })}
      </IconContainerHeaderWrapper>
      <IconContainerText>{renderElement({ id: "text" })}</IconContainerText>
    </IconContainerWrapper>
  );
});
